import { setRouteBase } from '@/config/routePrefix'

/**
 * @description: 通过集群修正国家参数
 * @param {string} cluster 集群变量
 * @param {boolean} type  通过type 返回当前是否为国家或者集群【仅对新加坡有效】
 * @param {string} location 属性
 * @return {string} 国家、集群
 */
export default function setCluster({
  cluster = '',
  type = false,
  locations = {},
}) {
  if (!cluster) return 'id'
  const prefix = setRouteBase(locations)
  const _cluster = cluster.trim().toLowerCase() //集群
  let result = ''

  if (_cluster && _cluster.toLowerCase() === 'sgp') {
    if (type) {
      result = 'id'
    } else {
      result = prefix && prefix.indexOf('br') > -1 ? 'br' : 'sgp'
    }
  } else {
    result = _cluster
  }
  return result
}
